import { render, staticRenderFns } from "./LaborExportDetailInfo.vue?vue&type=template&id=352e2cb6&"
import script from "./LaborExportDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./LaborExportDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports